export type DrinkIDs =
  | 'ristretto'
  | 'espresso'
  | 'cappuccino'
  | 'creme'
  | 'filter'
  | 'schale'
  | 'latte'
  | string

export type drinkSpecType = {
  name_de: string
  name_table_de: string
  name_fr: string
  name_table_fr: string
  desc_de: string
  desc_fr: string
  quantity: number
  coffee: number
  caffeine_100ml: number
  caffeine_drink: number
  brew: 'press' | 'filter' | 'pressfilter'
  cup: 'creme' | 'espresso' | 'filter' | 'chino'
  abbr: string
  id: DrinkIDs
}

export const drinkSpecs: { [k in DrinkIDs]: drinkSpecType } = {
  ristretto: {
    name_de: 'Ristretto',
    name_table_de: 'Ristretto (Kolben)',
    name_fr: 'Ristretto',
    name_table_fr: 'Ristretto (piston)',
    desc_de: '20 ml Kaffee',
    desc_fr: '20 ml de café',
    quantity: 20,
    coffee: 0,
    caffeine_100ml: 285,
    caffeine_drink: 57,
    brew: 'press',
    cup: 'espresso',
    abbr: 'ris',
    id: 'ristretto',
  },
  espresso: {
    name_de: 'Espresso',
    name_table_de: 'Espresso (KVA)',
    name_fr: 'Expresso',
    name_table_fr: 'Expresso (MA)',
    desc_de: '35 ml Kaffee',
    desc_fr: '35 ml de café',
    quantity: 35,
    coffee: 0,
    caffeine_100ml: 199,
    caffeine_drink: 70,
    brew: 'press',
    cup: 'espresso',
    abbr: 'esp',
    id: 'espresso',
  },
  filter: {
    name_de: 'Filterkaffee',
    name_table_de: 'Filterkaffee (Maschine)',
    name_fr: 'Café filtre',
    name_table_fr: 'Café filtre (Machine)',
    desc_de: '200 ml Kaffee',
    desc_fr: '200 ml de café',
    quantity: 200,
    coffee: 0,
    caffeine_100ml: 68,
    caffeine_drink: 136,
    brew: 'filter',
    cup: 'filter',
    abbr: 'fil',
    id: 'filter',
  },
  cappuccino: {
    name_de: 'Cappuccino',
    name_table_de: 'Cappuccino (KVA)',
    name_fr: 'Cappuccino',
    name_table_fr: 'Cappuccino (MA)',
    desc_de: '35 ml Kaffee + Milchschaum',
    desc_fr: '35 ml de café + mousse de lait',
    quantity: 35,
    coffee: 0,
    caffeine_100ml: 199,
    caffeine_drink: 70,
    brew: 'press',
    cup: 'chino',
    abbr: 'cap',
    id: 'cappuccino',
  },
  creme: {
    name_de: 'Café Crème',
    name_table_de: 'Café Crème (KVA)',
    name_fr: 'Café noir',
    name_table_fr: 'Café noir (MA)',
    desc_de: '110 ml Kaffee',
    desc_fr: '110 ml de café',
    quantity: 110,
    coffee: 0,
    caffeine_100ml: 59,
    caffeine_drink: 65,
    brew: 'press',
    cup: 'creme',
    abbr: 'cre',
    id: 'creme',
  },
  schale: {
    name_de: 'Schale',
    name_table_de: 'Schale (KVA)',
    name_fr: 'Café au lait',
    name_table_fr: 'Café au lait (MA)',
    desc_de: '110 ml Kaffee + Milch',
    desc_fr: '110 ml de café + lait',
    quantity: 110,
    coffee: 0,
    caffeine_100ml: 59,
    caffeine_drink: 65,
    brew: 'pressfilter',
    cup: 'filter',
    abbr: 'sch',
    id: 'schale',
  },
  latte: {
    name_de: 'Latte Macchiato',
    name_table_de: 'Latte Macchiato ',
    name_fr: 'Latte macchiato',
    name_table_fr: 'Latte macchiato (MA)',
    desc_de: '35 ml Kaffee + Milch + Milchschaum',
    desc_fr: '35 ml de café + lait + mousse de lait',
    quantity: 35,
    coffee: 0,
    caffeine_100ml: 199,
    caffeine_drink: 70,
    brew: 'pressfilter',
    cup: 'filter',
    abbr: 'lat',
    id: 'latte',
  },
  flatwhite: {
    name_de: 'Flat White',
    name_table_de: 'Flat White ',
    name_fr: 'Flat White',
    name_table_fr: 'Flat White (MA)',
    desc_de: '70 ml Kaffee + Milchschaum',
    desc_fr: '70 ml de café + mousse de lait',
    quantity: 70,
    coffee: 0,
    caffeine_100ml: 400, 
    caffeine_drink: 140,
    brew: 'press',
    cup: 'filter',
    abbr: 'flatwhite',
    id: 'flatwhite',
  },
}

export const drinkIcons: {
  [key: string]: string
} = {
  ristretto: require('../../assets/icons_ristretto.png'),
  espresso: require('../../assets/icons_espresso.png'),
  filter: require('../../assets/icons_filter.png'),
  cappuccino: require('../../assets/icons_cappuccino.png'),
  creme: require('../../assets/icons_creme.png'),
  schale: require('../../assets/icons_schale.png'),
  latte: require('../../assets/icons_latte.png'),
  flatwhite: require('../../assets/icons_flatwhite.png'),
}
